import { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const API_BASE = 'https://api.mahavihara-international.org';

export default function Donation() {
  const { currentLanguage, getText, LANGUAGES } = useLanguage();
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/donations`)
      .then(res => res.json())
      .then(json => {
        if (json.success) setDonations(json.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const isMM = currentLanguage === LANGUAGES.MM;

  return (
    <main className="donation-page">
      {/* Banner */}
      <section className="donation-hero">
        <div className="container text-center">
          <h1 className={`page-title ${isMM ? 'myanmar-text' : ''}`}>
            {getText({
              [LANGUAGES.EN]: 'Donation List',
              [LANGUAGES.MM]: 'အလှူရှင်များနှင့် အလှူငွေစာရင်း'
            })}
          </h1>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading ? (
            <p className={`text-center ${isMM ? 'myanmar-text' : ''}`}>
              {getText({
                [LANGUAGES.EN]: 'Loading...',
                [LANGUAGES.MM]: 'ဖတ်ရှုနေပါသည်...'
              })}
            </p>
          ) : (
            <div className="table-responsive shadow-medium">
              <table className="donation-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name (EN)</th>
                    <th className="myanmar-text">အမည် (MM)</th>
                    <th>Description (EN)</th>
                    <th className="myanmar-text">ဖော်ပြချက် (MM)</th>
                    <th>{getText({ [LANGUAGES.EN]: 'Amount', [LANGUAGES.MM]: 'ပမာဏ' })}</th>
                  </tr>
                </thead>

                <tbody>
                  {donations.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-muted">{index + 1}</td>

                      <td className="donation-name-en">
                        {item.name_en}
                      </td>

                      <td className="donation-name-mm myanmar-text">
                        {item.name_mm}
                      </td>

                      <td className="donation-desc-en">
                        {item.description_en || '-'}
                      </td>

                      <td className="donation-desc-mm myanmar-text">
                        {item.description_mm || '-'}
                      </td>

                      <td className="donation-amount-table">
                        {Number(item.amount).toLocaleString()} {item.currency}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}